/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:26 GMT
 */
const tokens = {
    semantic: {
        color: {
            text: {
                body: {
                    value: "#1e1e1e",
                    type: "color",
                },
                muted: {
                    value: "#676767",
                    type: "color",
                },
                disabled: {
                    value: "#b3b3b3",
                    type: "color",
                },
                inverse: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            action: {
                default: {
                    value: "#455D82",
                    type: "color",
                },
                hover: {
                    value: "#364262",
                    type: "color",
                },
                active: {
                    value: "#252C44",
                    type: "color",
                },
                disabled: {
                    value: "#D5E3F1",
                    type: "color",
                },
                onDark: {
                    default: {
                        value: "#B7CCE1",
                        type: "color",
                    },
                    hover: {
                        value: "#8AA8C7",
                        type: "color",
                    },
                    active: {
                        value: "#6381AB",
                        type: "color",
                    },
                    disabled: {
                        value: "#455D82",
                        type: "color",
                    },
                },
            },
            link: {
                default: {
                    value: "#385F99",
                    type: "color",
                },
                hover: {
                    value: "#294772",
                    type: "color",
                },
                active: {
                    value: "#21395B",
                    type: "color",
                },
                disabled: {
                    value: "#CDD7E5",
                    type: "color",
                },
            },
            background: {
                container: {
                    value: "#ffffff",
                    type: "color",
                },
                disabled: {
                    value: "#e6e6e6",
                    type: "color",
                },
                base: {
                    value: "#f4f6f8",
                    type: "color",
                },
                top: {
                    value: "#2F3B4D",
                    type: "color",
                },
                statusBar: {
                    value: "#202935",
                    type: "color",
                },
                selected: {
                    value: "#e6e6e6",
                    type: "color",
                },
            },
            status: {
                success: {
                    value: "#05704B",
                    type: "color",
                },
                warning: {
                    value: "#EAA14B",
                    type: "color",
                },
                warningText: {
                    value: "#935206",
                    type: "color",
                },
                error: {
                    value: "#AF292E",
                    type: "color",
                },
                new: {
                    value: "#E71613",
                    type: "color",
                },
                notification: {
                    value: "#385F99",
                    type: "color",
                },
            },
            destructive: {
                default: {
                    value: "#AF292E",
                    type: "color",
                },
                hover: {
                    value: "#821F22",
                    type: "color",
                },
                active: {
                    value: "#68181B",
                    type: "color",
                },
            },
            dataVisualization: {
                "01": {
                    value: "#6790cc",
                    type: "color",
                },
                "02": {
                    value: "#ff4066",
                    type: "color",
                },
                "03": {
                    value: "#277d83",
                    type: "color",
                },
                "04": {
                    value: "#ffb400",
                    type: "color",
                },
                "05": {
                    value: "#2f3b4b",
                    type: "color",
                },
                "06": {
                    value: "#3e8914",
                    type: "color",
                },
                "07": {
                    value: "#d64933",
                    type: "color",
                },
                "08": {
                    value: "#382458",
                    type: "color",
                },
            },
            transparent: {
                default: {
                    value: "#94949400",
                    type: "color",
                },
                hover: {
                    value: "#94949429",
                    type: "color",
                },
                active: {
                    value: "#94949452",
                    type: "color",
                },
            },
            accent: {
                "01": {
                    value: "#a5ccec",
                    type: "color",
                },
                "02": {
                    value: "#c0dbd1",
                    type: "color",
                },
                "03": {
                    value: "#efb5b5",
                    type: "color",
                },
                "04": {
                    value: "#f1c189",
                    type: "color",
                },
                "05": {
                    value: "#c1c1c1",
                    type: "color",
                },
            },
            ui: {
                focusRing: {
                    value: "#3e95fa",
                    type: "color",
                },
                divider: {
                    value: "#e6e6e6",
                    type: "color",
                },
            },
            placeholder: {
                value: "#676767",
                type: "color",
            },
        },
        shadow: {
            focus: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: 0,
                            offsetY: 0,
                            blur: 0,
                            spread: "1px",
                            color: "#ffffff",
                        },
                        {
                            inset: false,
                            offsetX: 0,
                            offsetY: 0,
                            blur: 0,
                            spread: "calc(2px + 1px)",
                            color: "#3e95fa",
                        },
                    ],
                    stringValue: "0 0 0 1px #ffffff, 0 0 0 calc(2px + 1px) #3e95fa",
                },
                type: "shadow",
            },
            focusInset: {
                value: {
                    layers: [
                        {
                            inset: true,
                            offsetX: 0,
                            offsetY: 0,
                            blur: 0,
                            spread: "2px",
                            color: "#3e95fa",
                        },
                        {
                            inset: true,
                            offsetX: 0,
                            offsetY: 0,
                            blur: 0,
                            spread: "3px",
                            color: "#ffffff",
                        },
                    ],
                    stringValue: "inset 0 0 0 2px #3e95fa, inset 0 0 0 3px #ffffff",
                },
                type: "shadow",
            },
            tooltip: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "8px",
                            blur: "16px",
                            spread: "0px",
                            color: "#0000001F",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "4px",
                            spread: "0px",
                            color: "#00000029",
                        },
                    ],
                    stringValue: "0px 8px 16px 0px #0000001F, 0px 0px 4px 0px #00000029",
                },
                type: "shadow",
            },
        },
        radius: {
            sm: {
                value: "2px",
                type: "dimension",
            },
            md: {
                value: "4px",
                type: "dimension",
            },
        },
        borderWidth: {
            none: {
                value: "0",
                type: "dimension",
            },
            thin: {
                value: "1px",
                type: "dimension",
            },
            thick: {
                value: "2px",
                type: "dimension",
            },
            focusWidth: {
                value: "2px",
                type: "dimension",
            },
            focusOffset: {
                value: "1px",
                type: "dimension",
            },
        },
        spacing: {
            none: {
                value: "0",
                type: "dimension",
            },
            xs: {
                value: "2px",
                type: "dimension",
            },
            sm: {
                value: "4px",
                type: "dimension",
            },
            default: {
                value: "8px",
                type: "dimension",
            },
            md: {
                value: "12px",
                type: "dimension",
            },
            lg: {
                value: "16px",
                type: "dimension",
            },
            xl: {
                value: "20px",
                type: "dimension",
            },
            "2xl": {
                value: "24px",
                type: "dimension",
            },
        },
        iconSize: {
            sm: {
                value: "16px",
                type: "dimension",
            },
            md: {
                value: "20px",
                type: "dimension",
            },
            lg: {
                value: "24px",
                type: "dimension",
            },
            xl: {
                value: "32px",
                type: "dimension",
            },
            "2xl": {
                value: "48px",
                type: "dimension",
            },
        },
        fontWeight: {
            light: {
                value: 300,
                type: "fontWeight",
            },
            regular: {
                value: 400,
                type: "fontWeight",
            },
            emphasis: {
                value: 600,
                type: "fontWeight",
            },
            link: {
                value: 700,
                type: "fontWeight",
            },
        },
        fontSize: {
            title: {
                billboard: {
                    value: "4rem",
                    type: "dimension",
                },
                display: {
                    value: "2.5rem",
                    type: "dimension",
                },
                lg: {
                    value: "1.75rem",
                    type: "dimension",
                },
                md: {
                    value: "1.375rem",
                    type: "dimension",
                },
                sm: {
                    value: "1.125rem",
                    type: "dimension",
                },
            },
            text: {
                body: {
                    value: "1rem",
                    type: "dimension",
                },
                md: {
                    value: "0.875rem",
                    type: "dimension",
                },
                sm: {
                    value: "0.8125rem",
                    type: "dimension",
                },
                xs: {
                    value: "0.75rem",
                    type: "dimension",
                },
            },
            label: {
                lg: {
                    value: "1rem",
                    type: "dimension",
                },
                sm: {
                    value: "0.75rem",
                    type: "dimension",
                },
            },
        },
        fontStyle: {
            placeholder: {
                value: "italic",
                type: "fontStyle",
            },
        },
        lineHeight: {
            title: {
                billboard: {
                    value: "5rem",
                    type: "dimension",
                },
                display: {
                    value: "3rem",
                    type: "dimension",
                },
                lg: {
                    value: "2rem",
                    type: "dimension",
                },
                md: {
                    value: "1.625rem",
                    type: "dimension",
                },
                sm: {
                    value: "1.5rem",
                    type: "dimension",
                },
            },
            text: {
                body: {
                    value: "1.25rem",
                    type: "dimension",
                },
                md: {
                    value: "1.125rem",
                    type: "dimension",
                },
                sm: {
                    value: "1rem",
                    type: "dimension",
                },
                xs: {
                    value: "0.875rem",
                    type: "dimension",
                },
            },
            label: {
                lg: {
                    value: "1rem",
                    type: "dimension",
                },
                sm: {
                    value: "0.8125rem",
                    type: "dimension",
                },
            },
        },
        letterSpacing: {
            label: {
                value: "1px",
                type: "dimension",
            },
            normal: {
                value: "0px",
                type: "dimension",
            },
        },
        textTransform: {
            label: {
                value: "uppercase",
                type: "textTransform",
            },
        },
    },
};
export default tokens;
